// removed by extract-text-webpack-plugin
module.exports = {"container_card":"styles__container_card___3sauj","danger":"styles__danger___1wMuu","info":"styles__info___2i1Xf","icon":"styles__icon___2ymAQ","icon_close":"styles__icon_close___2BmZj"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/Inputs/CardInfo/styles.css
// module id = 3158
// module chunks = 0